// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ulODr","newExpiryDate":"styles_newExpiryDate__1Jyz_","footer":"styles_footer__2zCRY"};